import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admins--language-switch"
export default class extends Controller {
  static targets = [
    "switch",
    "form",
    "field",
    "flag"
  ]

  static values = {
    language: String
  }

  init() {
    this.showFlag(this.languageValue)
    this.showField(this.languageValue)
    this.showSwitch(this.languageValue)
  }

  formTargetConnected() {
    this.init()
  }

  fieldTargetConnected() {
    this.showField(this.languageValue)
  }

  showSwitch(locale) {
    this.switchTargets.forEach(switchEl => {
      if (switchEl.value == locale) {
        switchEl.checked = true
      }
    })
  }

  showFlag(locale) {
    this.flagTargets.forEach(flag => {
      if (flag.lang == locale) {
        flag.classList.remove("hidden")
      } else {
        flag.classList.add("hidden")
      }
    })
  }

  showField(locale) {
    this.fieldTargets.forEach(field => {
      if (field.lang == locale) {
        field.classList.remove("hidden")
      } else {
        field.classList.add("hidden")
      }
    })
  }

  switchLanguage(event) {
    this.showField(event.currentTarget.value)
    this.showFlag(event.currentTarget.value)

    this.languageValue = event.currentTarget.value
  }
}
